var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner" }, [
    _c(
      "div",
      { staticClass: "app-main-page" },
      [
        _c(
          "span",
          {
            staticStyle: {
              position: "absolute",
              right: "10px",
              "margin-top": "5px"
            }
          },
          [
            _c(
              "el-link",
              {
                attrs: { type: _vm.lbAccountType },
                on: { click: _vm.selectAccountSetHandler }
              },
              [_vm._v(_vm._s(_vm.lbAccount))]
            )
          ],
          1
        ),
        _c("accounting-document-btn-group", { attrs: { type: _vm.type } }),
        _c("accounting-document-form", {
          ref: "documentForm",
          attrs: {
            "account-set": _vm.accountSet,
            type: _vm.type,
            "voucher-index": _vm.voucherIndex,
            "voucher-list": _vm.voucherList
          },
          on: { cancel: _vm.cancelCallBack }
        }),
        _c("account-set-popup", {
          ref: "refAccountSetPopup",
          attrs: {
            visible: _vm.accountSetPopup.visible,
            mode: _vm.accountSetPopup.mode,
            "load-mapping-departments-flag": false,
            "load-mapping-staffs-flag": false,
            "load-accounting-documents-rule-flag": false,
            "load-current-rates-flag": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.accountSetPopup, "visible", $event)
            },
            select: function(data) {
              return (_vm.accountSet = data)
            },
            cancel: function() {
              return (_vm.accountSetPopup.visible = false)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }